import { isLocalhost } from '../utils/localhost';

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

function isEnabled() {
  return Boolean(MEASUREMENT_ID) && !isLocalhost();
}

export function initAnalytics() {
  if (!isEnabled() || initialized) {
    return;
  }

  initialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID, { send_page_view: false });

  const connectBridge = () => bridgeSegmentToGA();

  if (window.analytics && typeof window.analytics.ready === 'function') {
    window.analytics.ready(connectBridge);
  } else {
    connectBridge();
  }
}

export function trackPageView(pagePath, pageTitle) {
  if (!isEnabled() || !window.gtag) {
    return;
  }

  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_title: pageTitle,
  });
}

export function trackEvent(eventName, params = {}) {
  if (!isEnabled() || !window.gtag) {
    return;
  }

  window.gtag('event', eventName, params);
}

function bridgeSegmentToGA() {
  if (!window.analytics || typeof window.analytics.track !== 'function') {
    return;
  }

  const originalTrack = window.analytics.track.bind(window.analytics);

  window.analytics.track = function trackWithGA(eventName, properties, options, callback) {
    trackEvent(eventName, properties);
    return originalTrack(eventName, properties, options, callback);
  };

  const originalPage = window.analytics.page.bind(window.analytics);

  window.analytics.page = function pageWithGA(category, name, properties, options, callback) {
    const pagePath = typeof category === 'string' ? `/${category}` : window.location.pathname;
    const pageTitle = typeof name === 'string' ? name : category || document.title;
    trackPageView(pagePath, pageTitle);
    return originalPage(category, name, properties, options, callback);
  };
}
